import { Flex } from 'reflexbox';
import {
  IconWrapper,
} from './styles';
import { ScheduleDut4 } from '../../providers/types/api-private';
import ReactTooltip from 'react-tooltip';
import { PenIcon } from '../../icons';
import { FaRegTrashAlt } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { dutControlOperation } from './constants';
import { colors } from '../../styles/colors';

interface ComponentProps {
  cardPosition: number;
  schedule: ScheduleDut4,
  hideButtons: boolean,
  onHandleEdit?,
  onHandleDelete?,
  irCommands?: { IR_ID: string, CMD_NAME: string, CMD_TYPE: string | null, TEMPER: number }[]
}

export const ScheduleViewCardDut4 = (props: ComponentProps): JSX.Element => {
  const { t } = useTranslation();

  const borderColor = props.schedule.SCHEDULE_STATUS ? colors.Blue300 : colors.GreyInputBorder;
  const operationText = props.schedule.CTRLOPER ? dutControlOperation.find((item) => item.value === props.schedule.CTRLOPER)?.label : '-';

  function colorTextDaySelected(day: boolean): string {
    return day ? colors.White : colors.Black;
  }

  function colorBackgroundDaySelected(day: boolean): string {
    return day ? colors.Blue300 : colors.Grey;
  }

  function scheduleTitle() {
    const overExtended = props.schedule.SCHEDULE_TITLE.length > 19;
    const nameDisplay = !overExtended ? props.schedule.SCHEDULE_TITLE : `${props.schedule.SCHEDULE_TITLE.substring(0, 19)}...`;

    return (
      <>
        <div style={{ marginTop: '6px', fontSize: '95%' }} data-tip data-for={props.schedule.SCHEDULE_TITLE}>
          <strong>
            {nameDisplay}
          </strong>
        </div>
        {overExtended && (
          <ReactTooltip
            id={props.schedule.SCHEDULE_TITLE}
            place="top"
            effect="solid"
            delayHide={100}
            offset={{ top: 0, left: 10 }}
            textColor={colors.Black}
            border
            backgroundColor="rgba(255, 255, 255, 0.97)"
          >
            <span style={{ marginTop: '6px', fontSize: '95%' }}>
              <strong>
                {props.schedule.SCHEDULE_TITLE}
              </strong>
            </span>
          </ReactTooltip>
        )}
      </>
    );
  }

  function scheduleStatus(): string {
    return props.schedule.SCHEDULE_STATUS ? t('habilitada') : t('desabilitada');
  }

  return (
    <Flex
      flexWrap="nowrap"
      flexDirection="column"
      height="258px"
      width="346px"
      style={{
        borderTop: `1px solid ${colors.GreyDefaultCardBorder}`,
        borderRight: `1px solid ${colors.GreyDefaultCardBorder}`,
        borderBottom: `1px solid ${colors.GreyDefaultCardBorder}`,
        borderLeft: `10px solid ${borderColor}`,
        borderRadius: '5px',
        marginLeft: '10px',
      }}
    >
      <Flex
        flexWrap="nowrap"
        flexDirection="row"
        style={{
          marginTop: '28px',
          marginLeft: '17px',
        }}
      >
        <div
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            width: '180px',
          }}
        >
          {scheduleTitle()}
        </div>
        <div
          style={{
            fontSize: '14px',
            marginLeft: '15px',
            fontWeight: 'bold',
          }}
        >
          {t('Programação')}
        </div>
      </Flex>
      <Flex
        flexWrap="nowrap"
        flexDirection="row"
        style={{
          marginLeft: '17px',
        }}
      >
        <div
          style={{
            width: '145px',
          }}
        >
          {!props.hideButtons && (
          <>
            <IconWrapper
              style={{ cursor: 'pointer' }}
              data-testid="schedule-edit-btn"
              onClick={(e) => { e.preventDefault(); props.onHandleEdit(props.cardPosition); }}
            >
              <PenIcon />
            </IconWrapper>
            <FaRegTrashAlt
              color={colors.Pink200}
              data-testid="schedule-delete-btn"
              style={{ marginLeft: '8px', cursor: 'pointer' }}
              onClick={(e) => {
                e.preventDefault();
                if (window.confirm(`Deseja excluir a programação ${props.schedule.SCHEDULE_TITLE}?`)) {
                  props.onHandleDelete(props.schedule.DUT_SCHEDULE_ID, props.cardPosition);
                }
              }}
            />
          </>
          )}
        </div>
        <div
          style={{
            fontSize: '14px',
            marginLeft: '50px',
          }}
        >
          {scheduleStatus()}
        </div>
      </Flex>
      <Flex
        flexWrap="nowrap"
        flexDirection="row"
        style={{
          marginTop: '10px',
          marginLeft: '17px',
        }}
      >
        <div style={{ border: `1px solid ${colors.LightLightGrey_v3}`, width: '293px' }} />
      </Flex>
      <Flex
        flexWrap="nowrap"
        flexDirection="row"
        style={{
          marginTop: '10px',
          marginLeft: '17px',
        }}
      >
        <div
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            width: '145px',
          }}
        >
          {t('modoOperacao')}
        </div>
      </Flex>
      <Flex
        flexWrap="nowrap"
        flexDirection="row"
        style={{
          marginLeft: '17px',
        }}
      >
        <div
          style={{
            fontSize: '14px',
            width: '145px',
          }}
        >
          {operationText || '-'}
        </div>
      </Flex>
      <Flex
        flexWrap="nowrap"
        flexDirection="row"
        style={{
          marginLeft: '17px',
          marginTop: '15x',
        }}
      >
        <div
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            width: '40px',
          }}
        >
          {t('inicio')}
        </div>
        <div
          style={{
            fontSize: '14px',
          }}
        >
          {props.schedule.BEGIN_TIME}
        </div>
      </Flex>
      <Flex
        flexWrap="nowrap"
        flexDirection="row"
        style={{
          marginLeft: '17px',
        }}
      >
        <div
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            width: '40px',
          }}
        >
          {t('fim')}
        </div>
        <div
          style={{
            fontSize: '14px',
          }}
        >
          {props.schedule.END_TIME}
        </div>
      </Flex>
      <Flex
        flexWrap="nowrap"
        flexDirection="row"
        style={{
          marginLeft: '17px',
          marginTop: '17px',
        }}
      >
        <div
          style={{
            width: '34px',
            height: '37px',
            borderRadius: '5px',
            backgroundColor: colorBackgroundDaySelected(props.schedule.DAYS.sun),
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              marginTop: '11px',
              color: colorTextDaySelected(props.schedule.DAYS.sun),
            }}
          >
            {t('diaDom').toLocaleUpperCase()}
          </div>
        </div>
        <div
          style={{
            width: '34px',
            height: '37px',
            borderRadius: '5px',
            marginLeft: '10px',
            backgroundColor: colorBackgroundDaySelected(props.schedule.DAYS.mon),
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              marginTop: '11px',
              color: colorTextDaySelected(props.schedule.DAYS.mon),
            }}
          >
            {t('diaSeg').toLocaleUpperCase()}
          </div>
        </div>
        <div
          style={{
            width: '34px',
            height: '37px',
            borderRadius: '5px',
            marginLeft: '10px',
            backgroundColor: colorBackgroundDaySelected(props.schedule.DAYS.tue),
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              marginTop: '11px',
              color: colorTextDaySelected(props.schedule.DAYS.tue),
            }}
          >
            {t('diaTer').toLocaleUpperCase()}
          </div>
        </div>
        <div
          style={{
            width: '34px',
            height: '37px',
            borderRadius: '5px',
            marginLeft: '10px',
            backgroundColor: colorBackgroundDaySelected(props.schedule.DAYS.wed),
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              marginTop: '11px',
              color: colorTextDaySelected(props.schedule.DAYS.wed),
            }}
          >
            {t('diaQua').toLocaleUpperCase()}
          </div>
        </div>
        <div
          style={{
            width: '34px',
            height: '37px',
            borderRadius: '5px',
            marginLeft: '10px',
            backgroundColor: colorBackgroundDaySelected(props.schedule.DAYS.thu),
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              marginTop: '11px',
              color: colorTextDaySelected(props.schedule.DAYS.thu),
            }}
          >
            {t('diaQui').toLocaleUpperCase()}
          </div>
        </div>
        <div
          style={{
            width: '34px',
            height: '37px',
            borderRadius: '5px',
            marginLeft: '10px',
            backgroundColor: colorBackgroundDaySelected(props.schedule.DAYS.fri),
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              marginTop: '11px',
              color: colorTextDaySelected(props.schedule.DAYS.fri),
            }}
          >
            {t('diaSex').toLocaleUpperCase()}
          </div>
        </div>
        <div
          style={{
            width: '34px',
            height: '37px',
            borderRadius: '5px',
            marginLeft: '10px',
            backgroundColor: colorBackgroundDaySelected(props.schedule.DAYS.sat),
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              marginTop: '11px',
              color: colorTextDaySelected(props.schedule.DAYS.sat),
            }}
          >
            {t('diaSab').toLocaleUpperCase()}
          </div>
        </div>
      </Flex>
    </Flex>
  );
};
